import isNil from 'lodash-es/isNil';
import { MediaPlayerError } from '@yi/core';

import { nr } from '~/common';
import { breakpoints } from '~/styles';

import { NEXT_BUTTON_CLASS_NAME } from './constants';
import { CONTROL_BAR_CLASS_NAME, QUALITY_MENU_WRAPPER_CLASS_NAME } from '../brightcove-constants';
import { ExtendedBrightcovePlayer } from '../types';

export const nextButtonStyles = `
  .${NEXT_BUTTON_CLASS_NAME} img{
    height: 100%;
    padding: 7px 0px 8px;
    ${breakpoints.minDesktop}{
      padding: 9px 0px 14px;
    }
  }
`;
export function addNextButton(player: ExtendedBrightcovePlayer): null | Element {
  const controlBar = player.$(`.${CONTROL_BAR_CLASS_NAME}`);
  if (isNil(controlBar)) {
    nr.noticeError(new MediaPlayerError('brightove player control bar is unavailable'));
    return null;
  }

  const insertAfterElement = player.$(`.${QUALITY_MENU_WRAPPER_CLASS_NAME}`);
  if (isNil(insertAfterElement)) {
    nr.noticeError(new MediaPlayerError('insertAfterElement is unavailable'));
    return null;
  }

  const existedNextButton = player.$(`.${NEXT_BUTTON_CLASS_NAME}`);
  if (!isNil(existedNextButton)) {
    return existedNextButton;
  }

  const buttonEl = document.createElement('button');
  buttonEl.className = `${NEXT_BUTTON_CLASS_NAME} vjs-control vjs-menu-button`;

  const icon = document.createElement('img');
  icon.setAttribute('src', '/images/chevron-right-white.svg');
  icon.setAttribute('aria-label', 'go to next video icon');
  buttonEl.appendChild(icon);

  controlBar.insertBefore(buttonEl, insertAfterElement.nextSibling);
  return buttonEl;
}
